import React, { Component } from 'react'
import { post } from '../../utils/networking'
import './style.css'
import { jsonFromUrlParam } from '../../utils'

const icon = require('../../assets/images/verify-icon.png')
const loading = require('../../assets/images/loading.png')

export default class Index extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errors: null,
            success: false,
            isProcessing: false
        }
    }

    componentWillMount() {
        let token = null
        let searchParam = jsonFromUrlParam(window.location.search)
        if (searchParam && searchParam.token) {
            token = searchParam.token
        }
        this.setState({
            errors: null,
            isProcessing: false,
            success: false
        })
        if (token) {
            this._handleVerify(token)
        }
    }
    _handleVerify(token) {
        this.setState({
            isProcessing: true
        })
        post('user/verify-email', { token: token }, "partner", result => {
            this.setState({
                success: true,
                isProcessing: false,
                errors: null
            })
            setTimeout(() => {
                this.props.history.push('/partner/login')
            }, 5000);
        }, errors => {
            this.setState({
                errors: errors.errors[0],
                isProcessing: false
            })
        })
    }

    render() {
        let {
            success,
            errors,
            isProcessing
        } = this.state
        return (
            <div id="verify-page">
                <div className="verify-icon" style={{ background: "url(" + icon + ")" }}>
                    <div>
                        {
                            isProcessing == true ? <img className={"spinner-img"} src={loading} /> : ""
                        }
                        {
                            success == true ? <span className="success">
                                <span>Verification was success</span>
                            </span> : ""
                        }
                        {
                            errors != null ? <span className="errors">{errors}</span> : ""
                        }
                        {
                            isProcessing == true ? <span>Waiting...</span> : ""
                        }
                    </div>
                    <span>VERIFY ACCOUNT</span>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/verify/index.js